/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';


export default {
  GetAllGroupsForDropDown,
  GetAllFactoriesByGroupID,
  GetViewOutletOrderOutletwise,
};

async function GetAllGroupsForDropDown() {
  const response = await CommonGet('/api/Group/GetAllGroups', null);
  return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
  const response = await CommonGet('/api/Factory/GetAllFactoriesByGroupID', 'groupID=' + parseInt(groupID));
  return response.data;
}

async function GetViewOutletOrderOutletwise(operationEntityID, date) {
const response = await CommonGet('/api/ViewOutletOrder/GetOutletOrder', 'operationEntityID=' + parseInt(operationEntityID)
+'&date=' + date);
  return response.data;
}






